import React from 'react';

const HelpCenterHeader = () => {
  return (
    <>
      <section
        className='page-header position-relative overflow-hidden pt-60 pb-60 '
      >
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-12 col-md-12'>
              <div className='text-center'>
                <h1 className=' fw-bold'>Privacy policy</h1>
                <p className='lead'>
                  This privacy policy for Senertech Software Private Limited (doing business as Senertech) (“we”, “us”, or “our”), describes how and why we might access, collect, store, use, and/or share (“process”) your personal information when you use our services (“services”), including when you visit our website at <a target="_blank" href="https://www.senertech.in">https://www.senertech.in</a> or any website of ours that links to this privacy policy or engage with us in other related ways, including any sales, marketing, or events.

                </p>
                <h3 className='fw-bold pt-40'>Questions or concerns?</h3>
                <p className='lead'>
                  Reading this privacy policy will help you understand your privacy rights and choices. We are responsible for making decisions about how your personal information is processed. If you do not agree with our policies and practices, please do not use our services.
                </p>              
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HelpCenterHeader;
